var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c(_vm.type,{tag:"component",attrs:{"params":_vm.data,"from":_vm.from,"fromParams":_vm.fromParams,"query":_vm.query,"conf":_vm.configure}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }